import $ from 'jquery';

function MenuCtrl(element) {
  this.element = element;
  this.$roots = this.getRootMenus();
  this.onClick = $.proxy(this.onClick, this);
  this.init();
}

MenuCtrl.prototype = {
  init() {
    this.addListeners();
    this.displayActiveMenus();
  },
  getRootMenus() {
    return $('a.depth-1', this.element);
  },
  onClick(event) {
    if ($(event.target).is('.menu-link')) {
      $(event.currentTarget).toggleClass('expand');
      event.preventDefault();
    }
  },
  displayActiveMenus() {
    $('.active-trail a.depth-1:not(.active)', this.element).addClass('expand');
  },
  addListeners() {
    this.$roots.bind('click', this.onClick);
  },
};

export default MenuCtrl;



// WEBPACK FOOTER //
// ./Menu.js